import React, { useEffect } from 'react';
import { ClubR } from '@rakutenfrance/shared-svg';
import { Typography, colorPalette, LinkOrSpan } from '@rakutenfrance/mui';
import { useTranslate } from '@rakutenfrance/tolgee-provider';
import { c as canopyStyle } from './index-498751b0.js';

var s = {"content":"_h-content-cdde","statusWrapper":"_h-statusWrapper-7d1a","product":"_h-product-e08c","deleteIcon":"_h-deleteIcon-3839","picProduct":"_h-picProduct-1f3e","warranty":"_h-warranty-eb90","bt":"_h-bt-eca7","noWrapText":"_h-noWrapText-398b"};

var formatPrice = function (price) {
    if (price && price >= 0) {
        return "".concat(price.toFixed(2), " \u20AC");
    }
    return '';
};
var PriceClub = function (_a) {
    var totalPointsToEarnAsMoney = _a.totalPointsToEarnAsMoney;
    var t = useTranslate('header').t;
    return (React.createElement("div", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['flex-column'], " ").concat(canopyStyle['flex-spacing-3'], " ").concat(canopyStyle['mb4'], " ").concat(canopyStyle['mt3'], " ").concat(canopyStyle['pa4']) },
        React.createElement(ClubR, { width: '51px', height: '20px' }),
        totalPointsToEarnAsMoney ? (React.createElement("p", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['flex-spacing-2'], " ").concat(canopyStyle['color-inherit']) },
            React.createElement(Typography, { className: s.noWrapText, variant: "body-default-semibold", color: colorPalette.red800 }, formatPrice(totalPointsToEarnAsMoney)),
            React.createElement(Typography, { variant: "body-default-regular" }, t('cart_tooltip_refund_money_label')))) : (React.createElement("p", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['flex-spacing-2'], " ").concat(canopyStyle['color-inherit']) },
            React.createElement(Typography, { className: s.noWrapText, variant: "body-default-semibold", color: colorPalette.red800 },
                t('cart_tooltip_price_club_label'),
                "\u00A0"),
            React.createElement(Typography, { variant: "body-default-semibold", color: colorPalette.red800 }, "5%\u00A0"),
            React.createElement(Typography, { variant: "body-default-semibold", color: colorPalette.red800 }, t('cart_tooltip_price_club_label_refund'))))));
};

var Membership = function () {
    var t = useTranslate('header').t;
    useEffect(function () {
        if (window.convertSpan) {
            window.convertSpan();
        }
    });
    return (React.createElement("div", { className: "".concat(canopyStyle['mt2'], " ").concat(canopyStyle['pb1']) },
        React.createElement(LinkOrSpan, { hasUnderline: false, href: '/event/club-rakuten' },
            React.createElement(Typography, { variant: "body-default-regular", color: colorPalette.blue500 }, t('cart_tooltip_membership_label')))));
};

export { Membership as M, PriceClub as P, s };
